import { render, staticRenderFns } from "./AgencySettings.vue?vue&type=template&id=fb7857d4&"
import script from "./AgencySettings.vue?vue&type=script&lang=js&"
export * from "./AgencySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AgencySettings.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VFlex,
})
